export enum MenuItemEnum {
  TOOLS = "tools",
  NEWS = "news",
  CONTACT = "contact",
  SCORE = "score"
}
